import { Box, Button, Dialog, DialogActions, DialogContent } from "@mui/material";
import { useContext, useRef, useState } from "react";
import { UsinasContext } from "../context/UsinasContextProvider";
import { DialogHeader } from "../../../auth/components/PasswordRecoveryModal";
import { ConfirmIndicatorsEditModal } from "./ConfirmIndicatorsEditModal";
import { Indicators } from "../types";
import { IndicatorsDataForm } from "./IndicatorsDataForm";
import { IndicatorEditSuccessModal } from "./IndicatorsEditSuccessModal";
import { IndicatorEditErrorModal } from "./IndicatorsEditErrorModal";
import { MainContext } from "../../../main/context/MainContextProvider";
import { ImportPVSystModal } from "./ImportPVSystModal";

export function IndicatorsDataModal(props: {
  open: boolean;
  setOpen: (open: boolean) => void;
}) {
  const { usina } = useContext(UsinasContext);
  const { userIsAdm, userIsClient } = useContext(MainContext);

  const { open, setOpen } = props;
  const [newIndicators, setNewIndicators] = useState<Indicators>();
  const [openIndicatorsEditModal, setOpenIndicatorsEditModal] = useState(false);
  const [openErrorModal, setOpenErrorModal] = useState(false);
  const [openSuccessModal, setOpenSuccessModal] = useState(false);
  const [openImportPVSystModal, setOpenImportPVSystModal] = useState(false);
  const [canEdit, setCanEdit] = useState(false);
  const usinaId = usina && "usinaIds" in usina ? usina.usinaIds.id : "";
  const onClose = () => setOpen(false);

  const formRef = useRef<HTMLFormElement | null>(null);
  const handleFormSubmit = async () => {
    if (formRef.current) formRef.current.submitForm();
  };
  return (
    <>
      <Dialog
        onClose={onClose}
        aria-labelledby="customized-dialog-title"
        open={open}
        fullWidth
        maxWidth="lg"
      >
        <DialogHeader id="customized-dialog-title" onClose={onClose}>
          Dados de Indicadores
        </DialogHeader>
        <DialogContent dividers>
          <IndicatorsDataForm
            setNewIndicators={setNewIndicators}
            setOpenIndicatorsEditModal={setOpenIndicatorsEditModal}
            open={open}
            ref={formRef}
            setCanEdit={setCanEdit}
          />
        </DialogContent>
        <DialogActions sx={{ display: "flex", justifyContent: "space-between" }}>
          <Box>
            <Button onClick={() => { setOpenImportPVSystModal(true) }}>Importar PVSyst</Button>
          </Box>
          <Box>
            <Button onClick={onClose}>Fechar</Button>
            {(userIsAdm || userIsClient) && (
              <Button
                disabled={!canEdit}
                variant="contained"
                color="primary"
                onClick={handleFormSubmit}
              >
                Editar
              </Button>
            )}</Box>
        </DialogActions>
      </Dialog>
      {newIndicators && (
        <ConfirmIndicatorsEditModal
          indicators={newIndicators}
          open={openIndicatorsEditModal}
          setOpen={setOpenIndicatorsEditModal}
          usinaId={usinaId}
          setOpenSuccessModal={setOpenSuccessModal}
          setOpenErrorModal={setOpenErrorModal}
        />
      )}
      <IndicatorEditSuccessModal
        open={openSuccessModal}
        setOpen={setOpenSuccessModal}
      />
      <ImportPVSystModal open={openImportPVSystModal}
        setOpen={setOpenImportPVSystModal} />
      <IndicatorEditErrorModal
        open={openErrorModal}
        setOpen={setOpenErrorModal}
      />
    </>
  );
}
